import { defineComponent, defineAsyncComponent, createApp, watch } from 'vue'
import { BlockModule } from '../common'
import { useBreakpoints } from '@vueuse/core'
import { tailwindBreakpoints } from '../tailwind'

new BlockModule({
    selector: '.block-carousel-stepper',
    async setupBlock(el, onTeardown) {
        let isSwiperInit = false
        const initSwiper = async () => {
            const swiperContainer = el.querySelector('.swiper') as HTMLElement

            if (!swiperContainer) return

            const [{ Swiper }, { Scrollbar }] = await Promise.all([
                import('swiper'),
                import('swiper/modules'),
                // @ts-ignore
                import('swiper/css'),
                // @ts-ignore
                import('swiper/css/scrollbar'),
            ])

            const slides =
                (Array.from(swiperContainer.querySelectorAll('.swiper-slide')) as HTMLElement[]) ||
                []

            if (slides.length <= 1) return

            const swiper = new Swiper(swiperContainer, {
                modules: [Scrollbar],
                slidesPerView: 'auto',
                spaceBetween: 20,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
            })

            isSwiperInit = true

            const slideElements = Array.from(el.querySelectorAll('.swiper-slide'))
            if (slideElements.length === 0) return
            const lastCard = slideElements[slideElements.length - 1]

            const targetSpan = el.querySelector('.gradient-overlay')
            if (!targetSpan) return

            targetSpan.classList.add('opacity-100', 'translate-x-0')

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            targetSpan.classList.remove('opacity-100', 'translate-x-0')
                            targetSpan.classList.add('opacity-0', 'translate-x-full')
                        } else {
                            targetSpan.classList.remove('opacity-0', 'translate-x-full')
                            targetSpan.classList.add('opacity-100', 'translate-x-0')
                        }
                    })
                },
                {
                    threshold: 0.8,
                },
            )

            observer.observe(lastCard)

            onTeardown(() => {
                swiper.destroy()
                observer.disconnect()
            })
        }

        const accordionCarouselBlock = el.querySelector('.accordion-carousel-stepper-block')

        if (accordionCarouselBlock) {
            const accordionCarouselAppComponent = defineComponent({
                name: 'accordion-carousel-stepper-block',
                components: {
                    Accordion: defineAsyncComponent(
                        () => import('@/components/ui/accordion/Accordion.vue'),
                    ),
                    AccordionContent: defineAsyncComponent(() =>
                        import('radix-vue').then((x) => x.AccordionContent),
                    ),
                    AccordionItem: defineAsyncComponent(() =>
                        import('radix-vue').then((x) => x.AccordionItem),
                    ),
                    AccordionTrigger: defineAsyncComponent(() =>
                        import('radix-vue').then((x) => x.AccordionTrigger),
                    ),
                },
                setup() {
                    const breakpoints = useBreakpoints(tailwindBreakpoints)
                    const xlAndGreater = breakpoints.greaterOrEqual('xl')

                    watch(
                        xlAndGreater,
                        (val) => {
                            if (val && !isSwiperInit) {
                                initSwiper()
                            }
                        },
                        { immediate: true },
                    )

                    return {
                        xlAndGreater,
                    }
                },
            })

            const accordionCarouselVueApp = createApp(accordionCarouselAppComponent)
            accordionCarouselVueApp.mount(accordionCarouselBlock)

            onTeardown(() => {
                accordionCarouselVueApp.unmount()
            })
        }
    },
})
